<template>
  <!--begin::Wrapper-->
  <div class="bg-white px-15 py-10">
    <div class="mb-10">
      <h1 class="text-dark">{{ translate("register_form_title") }}</h1>
      <div class="text-gray-400 fw-bold fs-6">
        {{ translate("register_form_subtitle") }}

        <router-link
          to="/sign-in"
          class="fs-5"
        >
          {{ translate("register_form_link_title") }}
        </router-link>
      </div>
    </div>

    <Form
      v-slot="{ errors }"
      class="row"
      ref="refForm"
      @submit="onSubmit"
      :validation-schema="validation"
    >
      <!-- ? Kullanıcı Bilgileri -->

      <div class="col-lg-6 pe-10">
        <span class="fs-2 mb-10">{{ translate("register_form_user_information") }}</span>
        <div class="row mb-3 mt-10">
          <div class="col-lg-4 d-flex align-items-center">
            <span
              class="required"
              style="vertical-align: middle"
              >{{ translate("FirstName") }}</span
            >
          </div>
          <div class="col-lg-8 fv-row d-v-container">
            <div class="fv-plugins-message-container d-v-content">
              <div class="fv-help-block v-element">
                <ErrorMessage name="firstName" />
              </div>
            </div>
            <Field
              type="text"
              class="form-control"
              name="firstName"
              :class="errors['firstName'] !== undefined ? 'v-invalid' : ''"
              v-model="user.firstname"
              :placeholder="translate('FirstName')"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-4 d-flex align-items-center">
            <span
              class="required"
              style="vertical-align: middle"
              >{{ translate("LastName") }}</span
            >
          </div>
          <div class="col-lg-8 fv-row d-v-container">
            <div class="fv-plugins-message-container d-v-content">
              <div class="fv-help-block v-element">
                <ErrorMessage name="lastName" />
              </div>
            </div>
            <Field
              type="text"
              class="form-control"
              name="lastName"
              v-model="user.lastname"
              :class="errors['lastName'] !== undefined ? 'v-invalid' : ''"
              :placeholder="translate('LastName')"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-4 d-flex align-items-center">
            <span
              class="required"
              style="vertical-align: middle"
              >{{ translate("EMail") }}</span
            >
          </div>
          <div class="col-lg-8 fv-row d-v-container">
            <div class="fv-plugins-message-container d-v-content">
              <div class="fv-help-block v-element">
                <ErrorMessage name="email" />
              </div>
            </div>
            <Field
              type="text"
              class="form-control"
              name="email"
              :class="errors['email'] !== undefined ? 'v-invalid' : ''"
              v-model="user.email"
              :placeholder="translate('EMail')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("customer_detail_label_country") }}</span>
          </div>
          <div class="col-lg-8">
            <Dropdown
              :filter="!platform"
              class="mb-3"
              :emptyFilterMessage="translate('No_Records')"
              v-model="user.countryId"
              :options="CountryList"
              optionLabel="Value"
              optionValue="Id"
              :placeholder="translate('customer_detail_label_country')"
              style="padding: 5px !important"
              appendTo="self"
              @change="getCity"
            >
              <template v-slot:indicator>
                <div
                  class="p-dropdown-trigger"
                  role="button"
                  aria-haspopup="listbox"
                  aria-expanded="false"
                >
                  <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                </div>

                <i
                  v-if="user.countryId === 0 ? false : true"
                  class="p-dropdown-clear-icon pi pi-times"
                  @click="(user.countryId = 0), getCity()"
                ></i>
              </template>
            </Dropdown>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("cityName") }}</span>
          </div>
          <div class="col-lg-8">
            <Dropdown
              :filter="!platform"
              class="mb-3"
              :emptyFilterMessage="translate('No_Records')"
              v-model="user.cityId"
              :options="newCityList"
              optionLabel="Value"
              optionValue="Id"
              :placeholder="translate('cityName')"
              style="padding: 5px !important"
              appendTo="self"
              @change="getDistrict"
            >
              <template v-slot:indicator>
                <div
                  class="p-dropdown-trigger"
                  role="button"
                  aria-haspopup="listbox"
                  aria-expanded="false"
                >
                  <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                </div>

                <i
                  v-if="user.cityId === 0 ? false : true"
                  class="p-dropdown-clear-icon pi pi-times"
                  @click="(user.cityId = 0), getDistrict()"
                ></i>
              </template>
            </Dropdown>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("register_form_district") }}</span>
          </div>
          <div class="col-lg-8">
            <Dropdown
              :filter="!platform"
              class="mb-3"
              :emptyFilterMessage="translate('No_Records')"
              v-model="user.districtId"
              :options="newDistrictList"
              optionLabel="Value"
              optionValue="Id"
              :placeholder="translate('register_form_district')"
              style="padding: 5px !important"
              appendTo="self"
            >
              <template v-slot:indicator>
                <div
                  class="p-dropdown-trigger"
                  role="button"
                  aria-haspopup="listbox"
                  aria-expanded="false"
                >
                  <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                </div>

                <i
                  v-if="user.districtId === 0 ? false : true"
                  class="p-dropdown-clear-icon pi pi-times"
                  @click="user.districtId = 0"
                ></i>
              </template>
            </Dropdown>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("register_form_street_address") }}</span>
          </div>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control"
              v-model="user.streetAddress"
              :placeholder="translate('register_form_street_address')"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("PhoneNumber") }}</span>
          </div>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control"
              v-model="user.phone"
              :placeholder="translate('PhoneNumber')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("company_detail_modal_label_default_language") }}</span>
          </div>
          <div class="col-lg-8">
            <Dropdown
              :filter="!platform"
              class="mb-3"
              :emptyFilterMessage="translate('No_Records')"
              v-model="user.defaultLanguageId"
              :options="languageList"
              optionLabel="Value"
              optionValue="Id"
              :placeholder="translate('company_detail_modal_label_default_language')"
              style="padding: 5px !important"
              appendTo="self"
            >
              <template v-slot:indicator>
                <div
                  class="p-dropdown-trigger"
                  role="button"
                  aria-haspopup="listbox"
                  aria-expanded="false"
                >
                  <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                </div>

                <i
                  v-if="user.defaultLanguageId === 0 ? false : true"
                  class="p-dropdown-clear-icon pi pi-times"
                  @click="user.defaultLanguageId = 0"
                ></i>
              </template>
            </Dropdown>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 d-flex align-items-center">
            <span
              class="required"
              style="vertical-align: middle"
              >{{ translate("user_modal_label_user_time_zone") }}</span
            >
          </div>
          <div class="col-lg-8 fv-row d-v-container">
            <div
              class="fv-plugins-message-container d-v-content"
              style="z-index: 1"
            >
              <div class="fv-help-block v-element">
                <ErrorMessage name="timeZone" />
              </div>
            </div>
            <Field
              name="timeZone"
              v-model="user.timezoneId"
            >
              <Dropdown
                :filter="!platform"
                :emptyFilterMessage="translate('No_Records')"
                :showClear="true"
                v-model="user.timezoneId"
                :options="timeZoneList"
                optionLabel="Value"
                optionValue="Id"
                :placeholder="translate('user_modal_select_user_time_zone')"
                style="padding: 5px !important"
                :style="`${errors['timeZone'] !== undefined ? 'border-color: #f31f0c77 !important;' : ''}`"
                appendTo="self"
              >
              </Dropdown>
            </Field>
          </div>
        </div>
      </div>

      <!-- ? Firma Bilgileri -->
      <div class="col-lg-6 ps-10">
        <span class="fs-2 mb-10">{{ translate("Menu_CompanyPage") }}</span>
        <div class="row mb-3 mt-10">
          <div class="col-lg-4 d-flex align-items-center">
            <span
              class="required"
              style="vertical-align: middle"
              >{{ translate("company_detail_modal_label_name") }}</span
            >
          </div>
          <div class="col-lg-8 fv-row d-v-container">
            <div class="fv-plugins-message-container d-v-content">
              <div class="fv-help-block v-element">
                <ErrorMessage name="companyName" />
              </div>
            </div>
            <Field
              type="text"
              class="form-control"
              name="companyName"
              :class="errors['companyName'] !== undefined ? 'v-invalid' : ''"
              v-model="user.companyName"
              :placeholder="translate('company_detail_modal_label_name')"
            />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("register_form_company_phone") }}</span>
          </div>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control"
              v-model="user.companyPhone"
              :placeholder="translate('register_form_company_phone')"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-4 d-flex align-items-center">
            <span
              class="required"
              style="vertical-align: middle"
              >{{ translate("register_form_company_email") }}</span
            >
          </div>
          <div class="col-lg-8 fv-row d-v-container">
            <div class="fv-plugins-message-container d-v-content">
              <div class="fv-help-block v-element">
                <ErrorMessage name="companyEmail" />
              </div>
            </div>
            <Field
              type="text"
              class="form-control"
              name="companyEmail"
              :class="errors['companyEmail'] !== undefined ? 'v-invalid' : ''"
              v-model="user.companyEmail"
              :placeholder="translate('register_form_company_email')"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("register_form_company_street_address") }}</span>
          </div>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control"
              v-model="user.companyStreetAddress"
              :placeholder="translate('register_form_company_street_address')"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("register_form_company_description") }}</span>
          </div>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control"
              v-model="user.companyDescription"
              :placeholder="translate('register_form_company_description')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("register_form_company_country") }}</span>
          </div>
          <div class="col-lg-8">
            <Dropdown
              :filter="!platform"
              class="mb-3"
              :emptyFilterMessage="translate('No_Records')"
              v-model="user.companyCountryId"
              :options="CountryList"
              optionLabel="Value"
              optionValue="Id"
              :placeholder="translate('countryName')"
              style="padding: 5px !important"
              appendTo="self"
              @change="getCompanyCity"
            >
              <template v-slot:indicator>
                <div
                  class="p-dropdown-trigger"
                  role="button"
                  aria-haspopup="listbox"
                  aria-expanded="false"
                >
                  <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                </div>

                <i
                  v-if="user.companyCountryId === 0 ? false : true"
                  class="p-dropdown-clear-icon pi pi-times"
                  @click="(user.companyCountryId = 0), getCompanyCity()"
                ></i>
              </template>
            </Dropdown>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("register_form_company_city") }}</span>
          </div>
          <div class="col-lg-8">
            <Dropdown
              :filter="!platform"
              class="mb-3"
              :emptyFilterMessage="translate('No_Records')"
              v-model="user.companyCityId"
              :options="CompanyCityList"
              optionLabel="Value"
              optionValue="Id"
              :placeholder="translate('cityName')"
              style="padding: 5px !important"
              appendTo="self"
              @change="getCompanyDistrict"
            >
              <template v-slot:indicator>
                <div
                  class="p-dropdown-trigger"
                  role="button"
                  aria-haspopup="listbox"
                  aria-expanded="false"
                >
                  <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                </div>

                <i
                  v-if="user.companyCityId === 0 ? false : true"
                  class="p-dropdown-clear-icon pi pi-times"
                  @click="(user.companyCityId = 0), getCompanyDistrict()"
                ></i>
              </template>
            </Dropdown>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-lg-4 d-flex align-items-center">
            <span style="vertical-align: middle">{{ translate("register_form_company_district") }}</span>
          </div>
          <div class="col-lg-8">
            <Dropdown
              :filter="!platform"
              class="mb-3"
              :emptyFilterMessage="translate('No_Records')"
              v-model="user.companyDistrictId"
              :options="CompanyDistrictList"
              optionLabel="Value"
              optionValue="Id"
              :placeholder="translate('register_form_district')"
              style="padding: 5px !important"
              appendTo="self"
            >
              <template v-slot:indicator>
                <div
                  class="p-dropdown-trigger"
                  role="button"
                  aria-haspopup="listbox"
                  aria-expanded="false"
                >
                  <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                </div>

                <i
                  v-if="user.companyDistrictId === 0 ? false : true"
                  class="p-dropdown-clear-icon pi pi-times"
                  @click="user.companyDistrictId = 0"
                ></i>
              </template>
            </Dropdown>
          </div>
        </div>

        <span class="fs-2 mb-10">{{ translate("register_form_password_information") }}</span>
        <div class="row mb-3 mt-10">
          <div class="col-lg-4 d-flex align-items-center">
            <span
              class="required"
              style="vertical-align: middle"
              >{{ translate("user_detail_public_label_password") }}</span
            >
          </div>
          <div class="col-lg-8 fv-row d-v-container">
            <div class="fv-plugins-message-container d-v-content">
              <div class="fv-help-block v-element">
                <ErrorMessage name="password" />
              </div>
            </div>
            <Field
              type="password"
              class="form-control"
              name="password"
              :class="errors['password'] !== undefined ? 'v-invalid' : ''"
              v-model="user.password"
              :placeholder="translate('user_detail_public_label_password')"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-4 d-flex align-items-center">
            <span
              class="required"
              style="vertical-align: middle"
              >{{ translate("Confirm_Password") }}</span
            >
          </div>
          <div class="col-lg-8 fv-row d-v-container">
            <div class="fv-plugins-message-container d-v-content">
              <div class="fv-help-block v-element">
                <ErrorMessage name="passwordRepeat" />
              </div>
            </div>
            <Field
              type="password"
              class="form-control"
              name="passwordRepeat"
              v-model="user.passwordRepeat"
              :class="errors['passwordRepeat'] !== undefined ? 'v-invalid' : ''"
              :placeholder="translate('Confirm_Password')"
            />
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-5">
        <button
          class="btn btn-light me-2"
          @click="router.push({ name: 'sign-in' })"
        >
          {{ translate("Cancel") }}
        </button>
        <button
          type="submit"
          class="btn btn-primary"
        >
          <div
            v-if="spinnerLoading"
            class="spinner-border spinner-border-sm mx-1"
          ></div>
          <span class="indicator-label">
            {{ translate("Submit") }}
          </span>
        </button>
      </div>
    </Form>
  </div>
</template>

<script setup>
import { reactive, computed, ref } from "vue";
import { Field, ErrorMessage, Form } from "vee-validate";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useToast } from "primevue/usetoast";
import * as Yup from "yup";

const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const store = useStore();
const platform = store.state.platform;
const spinnerLoading = ref(false);

const user = reactive({
  firstname: null,
  lastname: null,
  email: null,
  countryId: 0,
  cityId: 0,
  districtId: 0,
  streetAddress: null,
  phone: null,
  defaultLanguageId: 0,
  password: null,
  passwordRepeat: null,
  uploadImage: null,
  timezoneId: null,
  companyName: null,
  companyPhone: null,
  companyEmail: null,
  companyStreetAddress: null,
  companyDescription: null,
  companyCountryId: 0,
  companyCityId: 0,
  companyDistrictId: 0,
});

const router = useRouter();

const getDatas = () => {
  store.dispatch("LanguageModule/GET_ALL_COUNTRY");
  store.dispatch("LanguageModule/GET_LOCALİZATON");
  store.dispatch("UsersModule/GET_TIME_ZONES");
};

const CountryList = computed(() => store.getters["LanguageModule/_getCountryList"]);

const CompanyCityList = ref([]);
const CompanyDistrictList = ref([]);
const newCityList = ref([]);
const newDistrictList = ref([]);

const languageList = computed(() => store.getters["LanguageModule/_getLocalizatonList"]);
const timeZoneList = computed(() => store.getters["UsersModule/_getTimeZones"]);

const getDistrict = () => {
  user.districtId = 0;
  store.dispatch("LanguageModule/GET_DISTRICT", user.cityId).then((response) => {
    newDistrictList.value = response;
  });
};

const getCity = () => {
  user.cityId = 0;
  user.districtId = 0;
  store.dispatch("LanguageModule/GET_CITYS", user.countryId).then((response) => {
    newCityList.value = response;
  });
  store.dispatch("LanguageModule/GET_DISTRICT", user.cityId).then((response) => {
    newDistrictList.value = response;
  });
};

const getCompanyDistrict = () => {
  user.companyDistrictId = 0;
  store.dispatch("LanguageModule/GET_DISTRICT", user.companyCityId).then((response) => {
    CompanyDistrictList.value = response;
  });
};

const getCompanyCity = () => {
  user.companyCityId = 0;
  user.companyDistrictId = 0;
  store.dispatch("LanguageModule/GET_CITYS", user.companyCountryId).then((response) => {
    CompanyCityList.value = response;
  });
  store.dispatch("LanguageModule/GET_DISTRICT", user.companyCityId).then((response) => {
    CompanyDistrictList.value = response;
  });
};

const validation = Yup.object().shape({
  firstName: Yup.string().nullable().required(translate("user_modal_validation_fname")),
  lastName: Yup.string().nullable().required(translate("user_modal_validation_lname")),
  email: Yup.string()
    .nullable()
    .required(translate("user_modal_validation_email"))
    .email(translate("CustomerAdd_Valid_EMailFormat")),
  timeZone: Yup.string().nullable().required(translate("user_modal_validation_time_zone")),
  companyName: Yup.string().nullable().required(translate("audit_planning_validation_companyName")),
  companyEmail: Yup.string()
    .nullable()
    .required(translate("user_modal_validation_email"))
    .email(translate("CustomerAdd_Valid_EMailFormat")),
  password: Yup.string().nullable().required(translate("user_modal_validation_password")),
  passwordRepeat: Yup.string()
    .nullable()
    .test("password_match", translate("user_modal_validation_confirm_password"), function (value) {
      return this.parent.password === value;
    }),
});

const onSubmit = () => {
  spinnerLoading.value = true;
  store.dispatch("AuthModule/REGISTER", user).then((response) => {
    if (response) {
      setTimeout(() => {
        router.push({ name: "sign-in" });
      }, 300);

      spinnerLoading.value = false;
    } else {
      spinnerLoading.value = false;
    }
  });
};
getDatas();
</script>
